export default function initHeader() {
    const header = document.querySelector(".site-header");
    let lastScroll = 0;

    window.addEventListener("scroll", function () {
        const currentScroll = window.pageYOffset;

        if (currentScroll > 100) {
            header.classList.add("sticky-active");
        } else {
            
            header.classList.remove("sticky-active");
        }

        lastScroll = currentScroll;
    });
}
